module.exports = __webpack_public_path__ + "static/img/star1.c59e40fa.png";